﻿
const daysBeforeMonth = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334] as const;

function addZero(value: number) { if (value < 10) return "0" + value; return "" + value; }


export function getDayOfYear(data: Date): number
{
    const year = data.getFullYear();
    const month = data.getMonth();
    const day = data.getDate();
    const elapsedBeforeMonth = daysBeforeMonth[month];
    if (elapsedBeforeMonth === undefined || !Number.isFinite(year) || !Number.isFinite(day))
        return Number.NaN;
    const leapDay = month > 1 && isLeapYear(year) ? 1 : 0;
    return elapsedBeforeMonth + day + leapDay;
}

function isLeapYear(year: number): boolean {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

export function getShortTime(date: Date) 
    {
    if (!date) return "---";
    return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
    }

/**
* Возвращает дату с препиской, сегодня-вчера
* @returns {string}
* @param {Date} date
*/
export function getNamedTime(date: Date) 
{
    if (!date) return "---";
    const now = new Date();
    if (date.getFullYear()!==now.getFullYear())
        return addZero(date.getDate()) + '.' + addZero(date.getMonth()+1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
    const nowDays = getDayOfYear(now);
    const dateDays = getDayOfYear(date);

    const delta = nowDays-dateDays;        
    switch (delta)
    {
        case 0:
            return 'сегодня ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());        
        case 1:
            return 'вчера ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());        
        case 2:
            return 'позавчера ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());        
    }        
    return addZero(date.getDate()) + '.' + addZero(date.getMonth()+1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
}

/**
* @returns {string}
* @param {Date} date
*/
export function getDate(date: Date) 
{        
    return addZero(date.getDate()) + '.' + addZero(date.getMonth()+1) + '.' + addZero(date.getFullYear());
}

/**
* @returns {string}
* @param {Date} date
*/
export function getTime(date: Date) 
{        
    return addZero(date.getHours()) + ':' + addZero(date.getMinutes());
}

/**
* @returns {Date}
* */
export function getNow()
{
    return new Date();
}

